import * as React from 'react';
import times = require('lodash/times'); // tslint:disable-line: no-require-imports

interface Props {
	fullscreen?: boolean;
}

export default class BusyIndicator extends React.Component<Props, {}> {

	public render() {
		return <div className={`busy-indicator ${this.props.fullscreen ? 'fullscreen' : ''}`}>
			<div className='busy-indicator-backdrop'>
				{this.getIndicator()}
			</div>
		</div>;
	}

	private getIndicator() {
		return <div className='busy-indicator-spinner busy-indicator-circle sk-fading-circle'>
			{times(12, index => <div key={index} className={`sk-circle sk-circle${index + 1}`} />)}
		</div>;
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/util/widgets/BusyIndicator.tsx